import { createLocaleBasedExperimentNormalizer, createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_GDPR_SIGN_OPT_IN_COPY = defineFcm('gdpr_sign_opt_in_copy')
	.asJson(
		createLocaleBasedExperimentNormalizer(
			createShapeNormalizer({
				type: 'object',
				shape: {
					prompt: { type: 'string', optional: true },
					opt_in: { type: 'string', optional: true },
					opt_out: { type: 'string', optional: true },
					opt_out_warning: { type: 'string', optional: true },
					form_error: { type: 'string', optional: true },
				},
			}),
		),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'petition page',
		description: `The copy to be used for the GDPR opt-in radio fields.
			If not specified, a default copy is used.
			Copy is selected based on the user's locale and the locales array in the JSON.
			Related FCM: gdpr_sign_opt_in`,
		import: false,
		template: {
			experiments: {
				gb_copy: {
					locales: ['en-GB'],
					variants: {
						control: {
							prompt: '',
							opt_in: '',
							opt_out: '',
							form_error: '',
							opt_out_warning: '',
						},
					},
				},
				es_copy: {
					locales: ['es-ES'],
					variants: {
						control: {
							prompt: '',
							opt_in: '',
							opt_out: '',
							form_error: '',
							opt_out_warning: '',
						},
					},
				},
			},
		},
	});
